// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xbWB","title":"styles_title__CNMX1"};